module.exports = require("reselect");


//////////////////
// WEBPACK FOOTER
// external "reselect"
// module id = 30
// module chunks = 0